import { Page } from "../Components/page";
import { useTreasuryClient } from "../lib/client";
import { useQuery } from "@tanstack/react-query";
import { useProfiles } from "../lib/profiles";
import { LoadingSpinner, WithFallback } from "../Components";
import { BankingInfoEditable } from "../Components/BankingInfo";

export function BankingInfo() {
  let treasuryClient = useTreasuryClient();
    let { active } = useProfiles();

    let { data: treasuryProfile, isLoading, status } = useQuery({
    queryKey: ["GET", `/profile/${active}`],
      queryFn: async function getProfileFn() {
          console.log("Got profile:", isLoading, treasuryProfile);
      return treasuryClient.getProfile()
    },
  })

  return <Page title="Banking Profile">
    <WithFallback pred={isLoading} fallback={<LoadingSpinner msg="Loading banking profile..."/>}>
        {!isLoading && <BankingInfoEditable profile={treasuryProfile} isEditingInitial={status === "success" && !treasuryProfile} /> }
    </WithFallback>
  </Page>
}

